var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsRectangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.032,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5961c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a41ac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161023",
    "data-name": "Group 161023",
    transform: "translate(1848 23608)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_140235",
    "data-name": "Rectangle 140235",
    transform: "translate(-1848 -23608)",
    fill: "#fff",
    stroke: "#dce1e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-microsoft-teams-2019",
    transform: "translate(-1836.341 -23595.082)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M40.6,18.038v5.736a4.3,4.3,0,1,1-8.6,0V16.6h7.17a1.434,1.434,0,0,1,1.43,1.438Zm-4.3-4.3a2.868,2.868,0,1,0-2.868-2.868A2.868,2.868,0,0,0,36.3,13.738Z",
    transform: "translate(-11.923 -5.849)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M29.341,17.189v7.887a7.17,7.17,0,0,1-7.648,7.154A7.333,7.333,0,0,1,15,24.831V15.755H27.906a1.434,1.434,0,0,1,1.435,1.434ZM22.17,13.6a4.3,4.3,0,1,0-4.3-4.3,4.3,4.3,0,0,0,4.3,4.3Z",
    transform: "translate(-7.113 -5)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 4.481,
    cy: 4.033,
    rx: 4.481,
    ry: 4.033,
    transform: "translate(10.755 0.179)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M22.887,29.55V20H15v9.075a7.583,7.583,0,0,0,.677,3.114h4.57a2.639,2.639,0,0,0,2.64-2.639Z",
    transform: "translate(-7.113 -9.245)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M15,20v9.075a7.572,7.572,0,0,0,.4,2.4h4.774a2.238,2.238,0,0,0,2.238-2.238V20Z",
    transform: "translate(-7.113 -9.245)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M21.932,20H15v9.075a7.545,7.545,0,0,0,.2,1.68h4.9a1.835,1.835,0,0,0,1.836-1.836V20Z",
    transform: "translate(-7.113 -9.245)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M16.906,28.341H5.434A1.434,1.434,0,0,1,4,26.906V15.434A1.434,1.434,0,0,1,5.434,14H16.906a1.434,1.434,0,0,1,1.434,1.434V26.906a1.434,1.434,0,0,1-1.434,1.435Z",
    transform: "translate(-4 -7.547)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M15.766,19H9.932v1.233h2.185V26.17h1.464V20.232h2.185Z",
    transform: "translate(-5.679 -8.961)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsRectangleIcon);
export default __webpack_public_path__ + "static/media/teams-rectangle-icon.7a38a9f715d1ca823b62fcf93d231af8.svg";
export { ForwardRef as ReactComponent };